export const aroundRadius = 50000
export const aroundPrecision = 15000
